export default __webpack_public_path__ + "static/media/landing_mat_detail.329da3ee.png";